import { FilaHorario } from "./interfaces";

/** "2026-09-12" -> "12/09/2026". */
export const fechaDMY = (iso: string | null | undefined): string => {
	const p = String(iso || "").slice(0, 10).split("-");
	return p.length === 3 && p[0] ? `${p[2]}/${p[1]}/${p[0]}` : "";
};

/** "2026-09-12 14:03:00" -> "12/09/2026". La hora no hace falta en la línea de historia. */
export const fechaCorta = fechaDMY;

/** "15:00" -> "3:00 pm". */
export const horaAmPm = (hhmm: string | null | undefined): string => {
	const m = /^(\d{1,2}):(\d{2})/.exec(String(hhmm || ""));
	if (!m) return "";
	const h = Number(m[1]);
	return `${h % 12 === 0 ? 12 : h % 12}:${m[2]} ${h < 12 ? "am" : "pm"}`;
};

export const rangoHoras = (inicio: string, fin: string): string => `${horaAmPm(inicio)} - ${horaAmPm(fin)}`;

export const minutos = (hhmm: string): number => {
	const m = /^(\d{1,2}):(\d{2})/.exec(String(hhmm || ""));
	return m ? Number(m[1]) * 60 + Number(m[2]) : 0;
};

export const horaDeMinutos = (min: number): string => `${String(Math.floor(min / 60)).padStart(2, "0")}:${String(min % 60).padStart(2, "0")}`;

/** Curso y módulo en un renglón, sin repetir el módulo si el curso ya lo trae. */
export const tituloHorario = (f: Pick<FilaHorario, "curso" | "modulo">, cursoCortoFn: (n: string) => string): string => {
	const c = cursoCortoFn(f.curso) || f.curso || "";
	const sin = (t: string) => (t || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
	// «Barbería 1» ya dice el curso: no «Barbería · Barbería 1».
	if (f.modulo && c && (sin(f.modulo).startsWith(sin(c)) || sin(f.modulo).startsWith(sin(f.curso)))) return f.modulo;
	return [c, f.modulo].filter(Boolean).join(" · ");
};

export const fechasTexto = (inicio: string, fin: string): string => `${fechaDMY(inicio)} - ${fechaDMY(fin)}`;

/** "monthlyPrice" / "recargo_1" -> "Monthly Price" / "Recargo 1". */
export const titulo = (clave: string): string =>
	clave.replace(/_/g, " ").replace(/([a-z])([A-Z0-9])/g, "$1 $2").replace(/\b\w/g, (c) => c.toUpperCase());

export const dinero = (simbolo: string, valor: number | string | null | undefined): string => {
	const n = Number(valor);
	if (valor === null || valor === undefined || valor === "" || Number.isNaN(n)) return "";
	return simbolo + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

/** Día de la semana de hoy con 0 = Lunes. */
export const hoySemana = (): number => (new Date().getDay() + 6) % 7;
